import React from 'react'
import ContactForm from '../ContactForm/ContactForm'


const ContactArea = (props) => {
    return (
        <section className="tp-contact-form-area section-padding">
            <div className="container">
                <div className="tp-contact-form-wrap">
                    <div className="tp-section-title">
                        <span>Connect</span>
                        <h2>Start the Conversation</h2>
                        <p>Whether you're planning an event, exploring a business opportunity, or seeking a strategic partnership, we'd love to hear from you.</p>
                    </div>
                    <ContactForm/>
                </div>
            </div>
            <div className="visible-rotate-text">
                <h1>Connect</h1>
            </div>
        </section>
    )
}

export default ContactArea;